/**
 * Faces shown in the hero social-proof row (components/RatingProof.tsx).
 * Replace with real buyers (with permission) as reviews arrive.
 */
export type Coach = {
  name: string
  role: string
  avatar: string
}

export const coaches: Coach[] = [
  {
    name: 'Laura M.',
    role: 'Art therapist',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/5d004807-f735-4145-ae73-17b8e25f7af2.jpg',
  },
  {
    name: 'Marcus T.',
    role: 'School counselor',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/da2e84b5-eca4-485e-9b8c-791938433a08.jpg',
  },
  {
    name: 'Daniela R.',
    role: 'Licensed therapist',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd46792a-19db-4af6-a359-943d0a6bab65.jpg',
  },
  {
    name: 'Grace L.',
    role: 'Clinical social worker',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3bdfecff-3f59-4b80-b6c8-e23e84f97773.jpg',
  },
  {
    name: 'Ben H.',
    role: 'Family therapist',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3a738592-caa6-4d61-87a1-b62de1e8661c.jpg',
  },
]
